import animation from '/assets/scripts/animation.js';
import cookies from '/assets/scripts/cookies.js';
import extra from '/assets/scripts/extra.js';
import navCart from '/assets/scripts/nav-cart.js';
import forms from '/assets/scripts/forms.js';
import slider from '/assets/scripts/slider.js';
// import transition from '/assets/scripts/transition.js';
import accessibility from '/assets/scripts/accessibility.js';
import learndashCertificateButton from '/assets/scripts/learndash-certificate-button.js';
import '/assets/scripts/icons.js'; // Simple auto-initializing icon system

document.addEventListener('DOMContentLoaded', function () {
  // transition();
  slider();
  navCart();
  extra();
  cookies();
  forms();
  animation();
  accessibility();
  learndashCertificateButton();
});
